import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
import { jsx as _jsx } from "react/jsx-runtime";
const styles = {
  grid: {
    marginRight: "-15px",
    marginLeft: "-15px",
    width: "auto"
  }
};
const useStyles = makeStyles(styles);
export default function GridContainer(props) {
  const {
    children,
    className = "",
    ...rest
  } = props;
  const classes = useStyles();
  return /*#__PURE__*/_jsx(Grid, {
    container: true,
    ...rest,
    className: classes.grid + " " + className,
    children: children
  });
}